import type { ReactNode } from 'react';
import React from 'react';

type SimpleCardProps = {
  padding?: string;
  children: ReactNode;
};

const SimpleCard = ({ padding = 'p-5', children }: SimpleCardProps) => {
  return (
    <div className={`overflow-hidden rounded-lg bg-white ${padding}`}>
      {children}
    </div>
  );
};

export default SimpleCard;
